/* global jQuery COMPONENTS knockDoorway gtag */

COMPONENTS.Utility = (function ($) {
  function Utility () {}

  Utility.prototype.checkScroll = function () {
    const $body = $('body')
    const $window = $(window)
    const scroll = $window.scrollTop()

    if (scroll >= 50) {
      $body.addClass('page-is-scrolled')
    } else {
      $body.removeClass('page-is-scrolled')
    }
  }

  Utility.prototype.initTheme = function () {
    const utility = this

    $('[control-menu-toggle]').click(function () {
      $('.header__menu').toggleClass('header__menu--closed')
      $('.menu-toggle').toggleClass('open')
      $('html, body').toggleClass('noscroll menu-open')
    })

    // FIXME: Should have a data attribute assigned to the child menu item
    // don't target elements by class
    $('.menu__link-parent').click(function (e) {
      e.preventDefault()
      // FIXME: Should have a data attribute assigned to the child menu item
      // don't target elements by class
      $(this).siblings('.child-nav').toggleClass('child-nav--open')
    })

    $(window).on('scroll', function () {
      utility.checkScroll()
    })
    utility.checkScroll()

    this.bannerInit()
  }

  Utility.prototype.initKnockLinks = function () {
    const $knockTour = $('a[href="#knock-tour"]')
    const $knockContact = $('a[href="#knock-contact"]')

    if (typeof $knockTour !== 'undefined') {
      $knockTour.each(function () {
        const $link = $(this)
        $link.click(function (e) {
          e.preventDefault()
          knockDoorway.openScheduling()
        })
      })
    }

    if (typeof $knockContact !== 'undefined') {
      $knockContact.each(function () {
        const $link = $(this)
        $link.click(function (e) {
          e.preventDefault()
          knockDoorway.openContact()
        })
      })
    }
  }

  Utility.prototype.initSpecialsLinks = function () {
    const $specialsLinks = $('a[href="#specials"]')

    if (typeof $specialsLinks !== 'undefined') {
      $specialsLinks.each(function () {
        const $link = $(this)
        $link.click(function (e) {
          e.preventDefault()
          $('[data-ecs-components-control="specials-trigger"]').trigger('click')
        })
      })
    }
  }

  Utility.prototype.initSightmapLinks = function () {
    const $sightmapLinks = $('a[href="#sightmap"]')

    if (typeof $sightmapLinks !== 'undefined') {
      $sightmapLinks.each(function () {
        const $link = $(this)
        $link.click(function (e) {
          e.preventDefault()
          $('[data-ecs-components-control="sightmap-trigger"]').trigger('click')
        })
      })
    }
  }

  Utility.prototype.getSliderArrowElem = function (_dir) {
    let ariaLabel = ''
    if (_dir === 'right') {
      ariaLabel = 'Scroll to the next slider element.'
    } else if (_dir === 'left') {
      ariaLabel = 'Scroll to the previous slider element.'
    }

    return `<button class="ecs__components__slider__arrow ecs__components__slider__arrow-${_dir}" aria-label="${ariaLabel}"><i class="icon sif-chevron-${_dir}-bold"></i></button>`
  }

  Utility.prototype.getSliderVars = function (_slidesToDisplay = 1, _sliderLink = null, _sliderFade = false, _sliderAdaptive = false, _sliderAutoplay = true, _sliderDotTitles = false) {
    const utility = this

    let sliderVars = {
      autoplay: _sliderAutoplay,
      adaptiveHeight: _sliderAdaptive,
      dots: true,
      buttons: true,
      infinite: true,
      speed: 1000,
      slidesToShow: _slidesToDisplay,
      asNavFor: _sliderLink,
      fade: _sliderFade,
      pauseOnHover: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ],
      prevArrow: utility.getSliderArrowElem('left'),
      nextArrow: utility.getSliderArrowElem('right')
    }

    if (_sliderDotTitles === true) {
      sliderVars.customPaging = function (slick, index) {
        var slidernav = $(slick.$slides[index]).find('[data-slidernav]').first().data('slidernav')
        return '<span class="ecs_span ecs_slider_dot">' + slidernav + '</span>'
      }
    }

    return sliderVars
  }

  Utility.prototype.initSliderCounters = function () {
    const $activeSliders = $('.slick-slider[data-ecs-components-slider-counter]')

    $activeSliders.each(function () {
      const $slider = $(this)
      const $counter = $slider.find('.slick-dots')
      $counter.addClass('slick-counter')

      $counter.html(1 + '/' + $slider.find('.slick-slide:not(.slick-cloned)').size())

      $slider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        // currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        const i = (currentSlide ? currentSlide : 0) + 1
        $counter.html(i + '/' + slick.slideCount)
      })
    })
  }

  Utility.prototype.log = function (_banner, _obj = false) {
    if (COMPONENTS.dev_mode) {
      console.log(_banner)

      if (_obj) {
        console.log(_obj)
      }
    }
  }

  Utility.prototype.bannerInit = function () {
    COMPONENTS.utility = new COMPONENTS.Utility()

    const banner = $('[data-ecs-components-control="banner"]')
    var contentHeight = banner.find('[data-ecs-components-control="banner-inner"]').outerHeight()
    const bannerCookie = COMPONENTS.utility.getCookieValue('_componentsBanner')

    $(banner).css('max-height', (contentHeight + 'px'))

    if (!bannerCookie > 0) {
      $(banner).removeClass('ecs_components__notification--closed')
    }

    $('[data-ecs-components-control="banner-toggle"]').click(function () {
      $(banner).toggleClass('ecs_components__notification--closed')
    })

    $(window).on('resize orientationchange', function () {
      contentHeight = banner.find('[data-ecs-components-control="banner-inner"]').outerHeight()
      $(banner).css('max-height', (contentHeight + 'px'))
    })
  }

  Utility.prototype.arrayColumn = function (_array, _columnName) {
    return _array.map(function (value, index) {
      return value[_columnName]
    })
  }

  Utility.prototype.initFormClickEvent = function () {
    $(document).on('scf_submit_success', function () {
      if (typeof gtag !== 'undefined') {
        gtag('event', 'Click', {
          event_category: 'Contact Form',
          event_label: 'Submit'
        })
      }
    })
  }

  Utility.prototype.wcagLinks = function () {
    $('a').each(function () {
      const $this = $(this)

      if ($this.attr('target') === '_blank') {
        const linkAriaLabel = $this.attr('aria-label')
        let currentLabel = null

        if (typeof linkAriaLabel !== 'undefined' && linkAriaLabel !== false) {
          if (!linkAriaLabel.includes('new tab')) {
            currentLabel = $this.attr('aria-label') + ' (opens in a new tab)'
          } else {
            currentLabel = $this.attr('aria-label')
          }
        } else {
          currentLabel = $this.text() + ' (opens in a new tab)'
        }

        if (currentLabel != null) {
          $this.attr('aria-label', currentLabel)
        }
      }
    })
  }

  $.fn.scrollTo = function (elem, speed) {
    $(this).animate({
      scrollTop: ($(this).scrollTop() - $(this).offset().right - 10) + $(elem).offset().right
    }, speed === undefined ? 1000 : speed)
    return this
  }

  Utility.prototype.setCookie = function (cname, cvalue, exdays, cpath) {
    const date = new Date()
    date.setTime(date.getTime() + (exdays * 24 * 60 * 60 * 1000))
    const expires = 'expires=' + date.toUTCString()

    // Set the document-level cookie
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=' + cpath + '/'
  }

  Utility.prototype.getCookieValue = function (cname) {
    const name = cname + '='
    const decodedCookie = decodeURIComponent(document.cookie)
    const ca = decodedCookie.split(';')

    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) == ' ') {
        c = c.substring(1)
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length)
      }
    }
    return ''
  }

  return Utility
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Hook into the main components init
  COMPONENTS.utility = new COMPONENTS.Utility()
  COMPONENTS.utility.initTheme()
  // COMPONENTS.utility.initKnockLinks()
  // COMPONENTS.utility.initSpecialsLinks()
  // COMPONENTS.utility.initSightmapLinks()
  COMPONENTS.utility.initFormClickEvent()
  COMPONENTS.utility.wcagLinks()
  setTimeout(function () {
    COMPONENTS.utility.initSliderCounters()
  }, 500)

  // Check if the SPACES app is present and the SightMap has been loaded.
  if ((typeof SPACES !== 'undefined') && SPACES.sightmapLoaded) {
    // Perform metrics here in the SPACES instance of SightMap
    SPACES.sightmapFactory.embed.on('metrics.unitList.unit.click', function (event) {
      // do push to dataLayer
      // Examples of captured metrics can be found here https://developers.sightmap.com/docs/sightmap-javascript-iframe-metrics-api#examples
    })
  }
})
